import { useQuery } from '@tanstack/react-query';
import { getApiClient } from '../api/apiClient';

import { signSuggestions } from '../utils/aiSignature';

import { addAiUtmParams } from '../utils/utmTags';


const apiClient = getApiClient('kisanVani');

export function useAiReplySuggestions(commentId) {
  return useQuery({
    queryKey: ['ai-suggestions', commentId],
    queryFn: async () => {
      const { data } = await apiClient.get(`/posts/comments/${commentId}/suggestions`);
      const result = data?.data ?? { suggestions: [], commentText: '' };
      return { ...result, suggestions: (result.suggestions ?? []).map(addAiUtmParams) };
    },
    select: signSuggestions,
    enabled: !!commentId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
